import React from "react";
import { useSelector } from "react-redux";
import Blog from "../Blog/Blog";

const Blogs = () => {
  const blogs = useSelector((state) => state?.blogs);
  const filters = useSelector((state) => state?.filters);

  const filterByAuthorName = (blog) => {
    const { authorNames } = filters;
    if (authorNames.length > 0) {
      return authorNames.includes(blog?.authorName);
    }
    return true;
  };

  const filterByCategoryName = (blog) => {
    const { blogCategories } = filters;
    if (blogCategories.length > 0) {
      return blogCategories.includes(blog?.blogCategory);
    }
    return true;
  };

  const searchByBlogName = (blog) => {
    const { search } = filters;
    if (search.length > 0) {
      const blogName = blog?.blogName.toLowerCase();
      const searchValue = search?.toLowerCase();
      return blogName.includes(searchValue);
    }
    return true;
  };

  return (
    <div  class="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
      {/* single card */}
      {blogs
        .filter(filterByAuthorName)
        .filter(filterByCategoryName)
        .filter(searchByBlogName)
        .map((blog) => (
          <Blog blog={blog} key={blog?.id} />
        ))}
    </div>
  );
};

export default Blogs;
